import { useEffect } from "react";
import { useAuthdAPI } from "../api";
import { useErrorToast } from "../showToast";

export interface Discount {
  campaign: string;
  code: string;
  used: boolean;
}

enum LoyaltyState {
  NoPrevOrder = "NoPrevOrder",
  DiscountCodes = "DiscountCodes",
}

type GetDiscountCodesResult =
  | {
      loyaltyState: LoyaltyState.NoPrevOrder;
    }
  | {
      discounts: Discount[];
      loyaltyState: LoyaltyState.DiscountCodes;
    };

export function useCoupons() {
  const showErrorToast = useErrorToast();
  const { data, error, isLoading } =
    useAuthdAPI<GetDiscountCodesResult>("coupons");

  useEffect(() => {
    if (!error) return;
    showErrorToast(error);
  }, [error, showErrorToast]);

  return {
    isLoading,
    coupons:
      data?.loyaltyState === LoyaltyState.DiscountCodes ? data.discounts : [],
  };
}
